export enum EventPreparationChildPopupType {
  Lineups = 'Lineups',
  Skins = 'Skins',
  Formations = 'Formations',
}
